import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import Hero from "./Hero";
import About from "./About";
import Causes from "./Causes";
import News from "./News";
import Join from "./Join";
import Contact from "./Contact";
import Footer from "./Footer";

export const HomePage = () => {
  const location = useLocation();

  useEffect(() => {
    const target = location.state?.scrollTo;
    if (target) {
      const el = document.getElementById(target);
      if (el) {
        // small timeout so layout is mounted
        setTimeout(
          () => el.scrollIntoView({ behavior: "smooth", block: "start" }),
          80
        );
      }
    } else {
      window.scrollTo({ top: 0 });
    }
  }, [location]);

  return (
    <div data-testid="ablemp-home" className="min-h-screen bg-[#F4F4F0]">
      <Header />
      <main>
        <Hero />
        <About />
        <Causes />
        <News />
        <Join />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
